<template>
  <div>
    <v-dialog v-model="show" v-bind="$attrs" persistent>
      <v-card>
        <v-card-title class="font-weight-bold">{{ header }}</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="6">
              <div class="ma-0">
                <iframe
                  :src="url"
                  width="200"
                  height="200"
                  frameBorder="0"
                  scrolling="no"
                  @load="pollQuery"
                ></iframe>
              </div>
            </v-col>
            <v-col cols="6" class="mt-13">
              <div class="scan-qr-code d-flex">
                <div class="mt-1 pr-1">
                  <v-icon x-large color="white darken-2">{{
                    mdiLineScan
                  }}</v-icon>
                </div>
                <div>
                  {{ $t("message.scan_alipayhk_qr1") }}
                  <br />
                  {{ $t("message.scan_alipayhk_qr2") }}
                </div>
              </div>
              <div class="download-app d-flex">
                <div class="mt-1 pr-1">
                  <img
                    width="40"
                    height="40"
                    src="@/assets/alipayhk_logo.svg"
                  />
                </div>
                <div>
                  <div class="font-weight-bold font-weight-bold">
                    {{ $t("message.download_alipayhk_app1") }}
                  </div>
                  <div>
                    {{ $t("message.download_alipayhk_app2") }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="font-italic font-weight-bold">
            {{ $t("message.auto_redirect_after_paid") }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="secondary" small @click.stop="updatePaymentStatus">
          <v-icon>{{mdiCashCheck}}</v-icon>{{ $t("label.payment_confirmed") }}
        </v-btn> -->
          <v-btn color="secondary" small @click.stop="show = false">
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </div>
</template>

<script>
import { mdiClose, mdiLineScan } from "@mdi/js";
import { InquiryPayment } from "@/api/publicServices";

export default {
  props: {
    value: Boolean,
    url: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    paymentId: {
      type: String,
      required: true,
    },
  },
  components: {
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        console.log("alipay dialog emit: " + value);
        this.reset();
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    polling: null,
    pollingNo: 0,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiClose,
    mdiLineScan,
  }),
  methods: {
    async inquiryPayment() {
      try {
        let data = { PaymentID: this.paymentId };
        this.pollingNo++;
        console.log("pollingNo: ", this.pollingNo);
        if (this.pollingNo > 11) {
          data.CallInquiryApi = true;
          console.log("data: ", data);
        }
        const response = await InquiryPayment(data);
        if (response.data.isSuccess) {
          this.updatePaymentStatus(true);
          console.log(response.data);
        } else if (response.data.Key == "FAIL") {
          this.updatePaymentStatus(false);
          console.log(response.data);
        }
      } catch (error) {
        // this.snackBarMsg.text = "Service Error";
        // this.snackBarMsg.show = true;
        console.log(error);
      }
    },
    updatePaymentStatus(status) {
      this.reset();
      console.log("alipay dialog emit: updatePaymentStatus");
      this.show = false;
      this.$emit("onAlipay", { paymentStatus: status });
    },
    reset() {
      console.log("reset");
      this.pollingNo = 0;
      clearInterval(this.polling);
    },
    pollQuery() {
      if (this.url) {
        this.polling = setInterval(() => {
          console.log("pollData");
          this.inquiryPayment();
        }, 5000);
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    console.log("destroy");
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.scan-qr-code {
  background-color: #b4cad5;
  padding: 3px;
  color: white;
  font-size: 14px;
}
.download-app {
  background-color: #c6e2fb;
  padding: 3px;
  color: black;
  font-size: 14px;
}

// @media (max-width: 960px) {
//   .v-dialog__content {
//     justify-content: center;
//     align-items: flex-start;
//   }
// }
</style>
